import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const ManagerPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default ManagerPVMonitorPage;
